import { SVG, SVGProps } from './svg'

export function IconDarkMode(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M4.6 8.5a10 10 0 0114.1-5.3c.2 0 .3.2.3.4v.2c0 .1 0 .3-.2.4a10 10 0 000 15.6l.2.4v.2c0 .2-.1.3-.3.4a10 10 0 01-14-12.3zM16 4.2L14 4a8 8 0 101.9 15.8 12 12 0 010-15.6z" />
    </SVG>
  )
}
